import { BitkitButton, IconCheck, IconCopy } from '@bitrise/bitkit-v2';
import { useEffect, useState } from 'react';
import { useCopyToClipboard } from 'usehooks-ts';

const COPIED_STATE_DURATION = 2000;

type CopyAsPromptButtonProps = {
  getPrompt: () => string;
  onCopied?: VoidFunction;
};

const CopyAsPromptButton = ({ getPrompt, onCopied }: CopyAsPromptButtonProps) => {
  const [isCopied, setCopied] = useState(false);
  const [, copy] = useCopyToClipboard();

  useEffect(() => {
    const timeoutId = isCopied ? window.setTimeout(() => setCopied(false), COPIED_STATE_DURATION) : undefined;

    return () => clearTimeout(timeoutId);
  }, [isCopied]);

  const onCopyClick = async () => {
    if (await copy(getPrompt())) {
      setCopied(true);
      onCopied?.();
    }
  };

  return (
    <BitkitButton size="md" variant="ai-secondary" icon={isCopied ? IconCheck : IconCopy} onClick={onCopyClick}>
      {isCopied ? 'Copied to clipboard' : 'Copy as prompt'}
    </BitkitButton>
  );
};

export default CopyAsPromptButton;
